export function mutationsBuilder(stateObj) {
	let mutations = {};
	Object.keys(stateObj).forEach((item) => {
		mutations[mutationFormat(item)] = (state, val) => {
			state[item] = val;
		};
	});
	return mutations;
}
export function mutationFormat(val) {
	return 'SET_' + val.replace(/\B(?=[A-Z])+/g, '_').toUpperCase();
}
export class cache_state {
	constructor() {
		this.notifyToken = "";
		//auth
		this.token = '';
		this.refreshToken = '';
		this.refreshTokenID = '';
		this.tokenExpirationTime = null;
		//keep
		this.channels = [];
	}
}
